// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".start[data-v-79f97db9]{top:0}.end[data-v-79f97db9]{bottom:0}.text-container[data-v-79f97db9]{position:absolute;z-index:2;pointer-events:none;touch-action:none;width:100%}.player-text[data-v-79f97db9]{padding:16px;font-size:16px;overflow:hidden}@media(max-width:320px){.player-text[data-v-79f97db9]{font-size:14px}}", ""]);
// Exports
module.exports = exports;
